<s1-modal #modal [title]="'iconModal.title'">
  <div class="row">
    <div class="col-2 text-center" *ngFor="let icon of icons; let i = index">
      <button type="button" class="btn-lg btn-block btn-secondary mr-2 mb-2" (click)="iconSelected(icon)">
        <i class="{{ icon }}" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</s1-modal>
